import { render, staticRenderFns } from "./ConfirmacaoEnvioDialog.vue?vue&type=template&id=f1077aea&scoped=true&lang=pug"
import script from "./ConfirmacaoEnvioDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoEnvioDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoEnvioDialog.vue?vue&type=style&index=0&id=f1077aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1077aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VTextField})
